module.exports = __webpack_public_path__ + "static/media/scope_work_img1.ac2e2bd8.png";